import Lenis from 'lenis';

class SmoothScroll {
    constructor() {
        this.lenis = null;
        this.init();
        this.reinitAfterChatbotOpen();
    }

    init() {
        const _this = this;

        this.lenis = new Lenis({
            // Usercentrics CMP renders its consent banner/modal as a
            // <usercentrics-root> custom element with its own internal
            // scroll. Lenis intercepts wheel/touch events globally, so
            // without this it swallows scroll input inside that modal.
            prevent: (node) => node.tagName === 'USERCENTRICS-ROOT',
        });

        function raf(time) {
            _this.lenis.raf(time);
            requestAnimationFrame(raf);
        }

        requestAnimationFrame(raf);
    }

    reinitAfterChatbotOpen() {
        const _this = this;

        window.addEventListener('message', (event) => {
            let data = event.data;

            try {
                data = JSON.parse(data);
            } catch (e) {
                return false;
            }

            if( data.type === 'voiceflow:open' ) {
                if( _this.lenis ) {
                    _this.lenis.destroy();
                }
            }

            if( data.type === 'voiceflow:close' ) {
                _this.init();
            }
        }, false);
    }
}

new SmoothScroll();